/* NOIR theme behaviours — product-card plating swatches */
(function () {
  function initCard(card) {
    if (card.__noirInit) return;
    card.__noirInit = true;
    var swatches = card.querySelectorAll('[data-noir-swatch]');
    var main = card.querySelector('[data-noir-main]');
    var link = card.querySelector('[data-noir-tile-link]');
    swatches.forEach(function (sw) {
      sw.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var img = sw.getAttribute('data-img');
        var href = sw.getAttribute('data-href');
        if (img && main) { main.src = img; }
        if (href && link) { link.setAttribute('href', href); }
        swatches.forEach(function (s) { s.setAttribute('aria-pressed', 'false'); });
        sw.setAttribute('aria-pressed', 'true');
      });
    });
  }
  function initAll() { document.querySelectorAll('[data-noir-tile]').forEach(initCard); }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
